import { render } from "./TabClassNews.vue?vue&type=template&id=aa78c0da"
import script from "./TabClassNews.vue?vue&type=script&lang=js"
export * from "./TabClassNews.vue?vue&type=script&lang=js"

import "./TabClassNews.vue?vue&type=style&index=0&id=aa78c0da&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__